import React, { useEffect, useState } from "react"
import { AvForm, AvField, AvCheckboxGroup, AvCheckbox, AvRadioGroup, AvRadio } from "availity-reactstrap-validation"
import store from "store";

import { ReactComponent as Warning } from 'assets/images/svg/warning.svg';
import { ReactComponent as Download } from 'assets/images/svg/download.svg';
import { ReactComponent as Delete } from 'assets/images/svg/delete.svg';


class Emitter extends React.PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            sector: '',
            businessType: '',
            companyListFile: [],
            companyTotalListFile: [],
            modalShow: false,
            dailyEmission: '',
            collection: '',
            desiredCollectionDays: [],
            area: '',
            waterPerDay: '',
            paymentWay: ''
        }
        const code = store.getState().Data?.code[0] || []
        this.sectors = code.filter(item => item.code === 'sectors')
        this.businessTypes = code.filter(item => item.code === 'business_types')
        this.dailyEmissions = code.filter(item => item.code === 'dailyEmissions')
        this.collections = code.filter(item => item.code === 'collections')
        this.desiredCollectionDays = code.filter(item => item.code === 'weeks')
        this.paymentWay = code.filter(item => item.code === 'paymentWay')
    }

    deleteFile = (str) => {
        this.setState({ [str]: [] })
    }

    isValiddate = () => {
        if (this.state.sector === '') {
            alert("업종을 선택해주세요.")
            return ""
        }
        if (this.state.businessType === '') {
            alert("사업장형태를 선택해주세요.")
            return ""
        }
        if (this.state.area.length > 0 && isNaN(this.state.area * 1)){
            return alert('사업장 면적에는 숫자가 들어가야 합니다.')
        }
        if (this.state.dailyEmission.length > 0 && isNaN(this.state.dailyEmission * 1)){
            return alert('일 배출량에는 숫자가 들어가야 합니다.')
        }
        if (this.state.waterPerDay.length > 0 && isNaN(this.state.waterPerDay * 1)){
            return alert('일 식수인원에는 숫자가 들어가야 합니다.')
        }
        if (this.state.collection === '') {
            alert("예상수거량을 선택해주세요.")
            return ""
        }
        if(this.state.desiredCollectionDays.length === 0){
            alert("희망수거일을 선택해주세요.")
            return ""
        }
        if (this.state.businessType === 'multi' && this.state.paymentWay === '') {
            alert("정산형태를 선택해주세요.")
            return ""
        }
        return "success";
    }

    registFiles = (str, e) => {
        this.setState({ [str]: [...e.target.files] })
    }

    fileDownload = async (str) => {
        let url = `https://waveradmin.ropiklabs.com/media/sample/${str}.xlsx`
        fetch(url)
            .then((response) => response.blob())
            .then((blob) => {
                const excelUrl = window.URL.createObjectURL(new Blob([blob]));
                const link = document.createElement('a');
                link.href = excelUrl;
                link.setAttribute('download', `${str}.xlsx`);
                document.body.appendChild(link);
                link.click();
            })
            .catch((error) => {
                console.error(error)
            })
    };

    handleDesiredCollectionDays = (item, num) => {                
        if(this.state.desiredCollectionDays.filter(itm => itm.key === item.key).length > 0){            
            this.setState({desiredCollectionDays : [...this.state.desiredCollectionDays.filter(value => value.key !== item.key)]})
        }else if(this.state.desiredCollectionDays.length < num){
            this.setState({desiredCollectionDays : [...this.state.desiredCollectionDays, item]})
        }        
    }

    render() {
        return (
            <>
                <div className="mb-4">
                    <p className="noMargin text-black font-weight-bold font-size-16">업종선택</p>
                    {this.sectors && this.sectors.map((item, index) => { return (
                        <div className="form-check form-check-inline mt-2" key={item.key+'_'+index}>
                            <input className="is-untouched is-pristine av-valid form-check-input" type='radio' id={item.key} name="sectors" value={item.key} onChange={()=>{this.setState({ sector: item.key })}} />
                            <label className="noMargin form-check-label font-size-16 text-black" htmlFor={item.key} >{item.text}</label>
                        </div>
                    )})
                    }
                </div>

                <div className="mb-4">
                    <p className="noMargin text-black font-weight-bold font-size-16">사업장형태</p>
                    {this.businessTypes && this.businessTypes.map((item, index) => { return (
                        <div className="form-check form-check-inline mt-2" key={item.key+'_'+index}>
                            <input className="is-untouched is-pristine av-valid form-check-input" type='radio' id={item.key} name="businessTypes" value={item.key} onChange={()=>{this.setState({ businessType: item.key })}} />
                            <label className="noMargin form-check-label font-size-16 text-black" htmlFor={item.key} >{item.text}</label>
                        </div>
                    )})
                    }
                </div>

                {this.state.businessType === 'multi' &&
                <>
                    <div className="mb-4">
                        <p className="noMargin text-black font-weight-bold font-size-16">정산형태</p>
                        {this.paymentWay && this.paymentWay.map((item, index) => { return (
                            <div className="form-check form-check-inline mt-2" key={item.key+'_'+index}>
                                <input className="is-untouched is-pristine av-valid form-check-input" type='radio' id={item.key} name="paymentWay" value={item.key} onChange={()=>{this.setState({ paymentWay: item.key })}} />
                                <label className="noMargin form-check-label font-size-16 text-black" htmlFor={item.key} >{item.text}</label>
                            </div>
                        )})
                        }
                    </div>

                    <div className="mb-4">
                        <p className="noMargin text-black font-weight-bold font-size-16">다수사업장 리스트 업로드</p>
                            <div className="download-container mt-2 d-flex flex-column justify-content-between" style={{height: 'fit-content'}}>
                                <div className="d-flex align-items-top">
                                    <Warning width={28} height={22} />
                                    <p className="noMargin font-size-14 text-black padding-left-8">사업장명/대표자명/사업장등록번호/우편번호/주소/연락처/일배출량/희망수거일 필수</p>
                                </div>
                                <div className="waver-pagination-btn-group float-right d-flex justify-content-end">
                                    <button className="waves-effect submit-btn btn btn-secondary font-size-14 mt-2"
                                    onClick={() => {
                                        this.fileDownload('다수사업장등록엑셀')
                                    }}
                                    >샘플 엑셀파일 다운로드<Download className="margin-left-8" />
                                    </button>
                                </div>
                            </div>
                        <label className="waves-effect waves-light btn btn-primary font-size-16 margin-top-16" htmlFor="ex_file">파일 선택</label>
                        <input style={{display: "none"}} type="file" accept=".xls,.xlsx" id="ex_file" onChange={(e)=>{
                        this.registFiles('companyListFile', e)
                        }}/>
                        {this.state.companyListFile?.length > 0 && this.state.companyListFile.map((item, index) => {
                        return (
                            <div className="file-confirm" key={index}>
                                <p className="noMargin">{item.name}</p>
                                <Delete className="margin-left-8 pointer" onClick={()=>{this.deleteFile('companyListFile')}} />
                            </div>
                        )
                        })
                        }
                    </div>
                </>
                }
                {this.state.businessType === 'total' &&
                    <div className="mb-4">
                        <p className="noMargin text-black font-weight-bold font-size-16">사업장배출자 리스트 업로드</p>
                            <div className="download-container mt-2 d-flex flex-column justify-content-between" style={{height: 'fit-content'}}>
                                <div className="d-flex align-items-top">
                                    <Warning width={28} height={22} />
                                    <p className="noMargin font-size-14 text-black padding-left-8">사업장명/대표자명/사업장등록번호/우편번호/주소/연락처/일배출량/희망수거일 필수</p>
                                </div>
                                <div className="waver-pagination-btn-group float-right d-flex justify-content-end">
                                    <button className="waves-effect submit-btn btn btn-secondary font-size-14 mt-2"
                                    onClick={() => {
                                        this.fileDownload('사업장배출자등록엑셀')
                                    }}
                                    >샘플 엑셀파일 다운로드<Download className="margin-left-8" />
                                    </button>
                                </div>
                            </div>
                        <label className="waves-effect waves-light btn btn-primary font-size-16 margin-top-16" htmlFor="ex_file">파일 선택</label>
                        <input style={{display: "none"}} type="file" accept=".xls,.xlsx" id="ex_file" onChange={(e)=>{
                        this.registFiles('companyTotalListFile', e)
                        }}/>
                        {this.state.companyTotalListFile?.length > 0 && this.state.companyTotalListFile.map((item, index) => {
                        return (
                            <div className="file-confirm" key={index}>
                                <p className="noMargin">{item.name}</p>
                                <Delete className="margin-left-8 pointer" onClick={()=>{this.deleteFile('companyTotalListFile')}} />
                            </div>
                        )
                        })
                        }
                    </div>
                }
                {(this.state.businessType === 'total' || this.state.businessType === 'many' || this.state.businessType === 'multi') &&
                <>
                    <div className="mb-4">
                        <p className="noMargin text-black font-weight-bold font-size-16">사업장 면적</p>
                        <div className="d-flex align-items-center mt-2">
                            <input className="is-touched is-dirty av-valid form-control font-size-16 w-50" onChange={(e)=>{
                                this.setState({area: e.target.value})
                            }} />
                            <p className="noMargin font-size-16">&nbsp;㎡</p>
                        </div>
                    </div>

                    <div className="mb-4">
                        <p className="noMargin text-black font-weight-bold font-size-16">일 식수인원</p>
                        <div className="d-flex align-items-center mt-2">
                            <input className="is-touched is-dirty av-valid form-control font-size-16 w-50" onChange={(e)=>{
                                this.setState({waterPerDay: e.target.value})
                            }} />
                            <p className="noMargin font-size-16">&nbsp;명</p>
                        </div>
                    </div>

                    <div className="mb-4">
                        <p className="noMargin text-black font-weight-bold font-size-16">일 배출량</p>
                        <div className="d-flex align-items-center mt-2">
                            <input className="is-touched is-dirty av-valid form-control font-size-16 w-50" onChange={(e)=>{
                                this.setState({dailyEmission: e.target.value})
                            }} />
                            <p className="noMargin font-size-16">&nbsp;Kg</p>
                        </div>
                    </div>
                </>
                }

                <div className="mb-4">
                    <p className="noMargin text-black font-weight-bold font-size-16">예상수거량(용기통 L수 확인 후 체크)</p>
                    {this.collections && this.collections.map((item, index) => { return (
                        <div className="form-check form-check-inline mt-2" key={item.key+'_'+index}>
                            <input className="is-untouched is-pristine av-valid form-check-input" type='radio' id={item.key} name="collections" value={item.key} onChange={()=>{this.setState({ collection: item.key })}} />
                            <label className="noMargin form-check-label font-size-16 text-black" htmlFor={item.key} >{item.text}</label>
                        </div>
                    )})
                    }
                </div>

                <div className="mb-4">
                    <p className="noMargin text-black font-weight-bold font-size-16">희망수거일(최대 3일까지 선택 가능)</p>
                    {this.desiredCollectionDays && this.desiredCollectionDays.map((item, index) => { return (
                        <div className="form-check form-check-inline mt-2" key={item.key+'_'+index}>
                            <input className="is-untouched is-pristine av-valid form-check-input" checked={this.state.desiredCollectionDays.filter(data => data.key == item.key).length > 0} type='checkbox' id={item.key} name="desiredCollectionDays" value={item.key} onChange={()=>{this.handleDesiredCollectionDays(item, 3)}} />
                            <label className="noMargin form-check-label font-size-16 text-black" htmlFor={item.key} >{item.text}</label>
                        </div>
                    )})
                    }
                </div>

                <div className="">
                    <div className="col-12 text-end">
                        <button
                            className="btn btn-primary w-md waves-effect waves-light mt-5 w-100 font-size-16"
                            type="submit"
                            onClick={() => {
                                if (this.isValiddate() === 'success') {
                                    this.props.handlePress({
                                        ...this.state
                                    })
                                }
                            }}
                        >
                            회원가입 완료하기
                        </button>
                    </div>
                </div>
            </>
        );
    }
};

export default Emitter;


